import { Field } from "@ark-ui/react/field";

import { css, cva, cx } from "../../styled-system/css";

export const inputStyles = cva({
  base: {},
  variants: {
    type: {
      errorText: {
        color: "destructive",
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "1.0",
        letterSpacing: "0",
        _empty: { display: "none" },
      },
      frame: {
        backgroundColor: "white",
        borderRadius: "4px",
        borderColor: "#E4E4E7",
        borderStyle: "solid",
        borderWidth: "1px",
        color: "foreground",
        height: "40px",
        width: "100%",
      },
      helperText: {
        color: "muted-foreground",
        display: "block",
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "1.0",
        letterSpacing: "0",
        _empty: { display: "none" },
      },
      input: {
        paddingBottom: "8px",
        paddingLeft: "12px",
        paddingRight: "12px",
        paddingTop: "8px",
      },
      label: {
        color: "card-foreground",
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "1.0",
        letterSpacing: "0",
        _empty: { display: "none" },
      },
      root: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        alignItems: "start",
      },
    },
  },
});

export type InputProperties = Field.InputProps & {
  /** 注意のテキスト */
  caution?: string;
  containerClassName?: string;
  containerProperties?: Field.RootProps;
  /** 説明のテキスト */
  description?: string;
  label?: string;
};

export function Input({
  className,
  caution,
  containerClassName,
  containerProperties,
  description,
  label,
  required,
  ...properties
}: InputProperties) {
  return (
    <Field.Root
      {...containerProperties}
      className={cx(
        inputStyles({ type: "root" }),
        containerClassName,
        containerProperties?.className,
      )}
      invalid={Boolean(caution)}
      required={required}
    >
      <Field.Label className={inputStyles({ type: "label" })}>{label}</Field.Label>
      <Field.Input
        className={cx(
          "peer",
          css(inputStyles.raw({ type: "frame" }), inputStyles.raw({ type: "input" })),
          className,
        )}
        {...properties}
      />
      <Field.HelperText
        className={cx(
          css(inputStyles.raw({ type: "helperText" }), Boolean(caution) && { display: "none" }),
        )}
      >
        {description}
      </Field.HelperText>
      <Field.ErrorText
        className={cx(
          inputStyles({ type: "errorText" }),
          caution ? css({ display: "block" }) : css({ display: "none" }),
        )}
      >
        {caution}
      </Field.ErrorText>
    </Field.Root>
  );
}
